'use strict';

var configure = require('./lib/configure');

module.exports = configure(function (_ref) {
  var apiAddr = _ref.apiAddr,
      apiPath = _ref.apiPath;
  var url = new URL(apiAddr);
  return function () {
    return {
      host: url.hostname,
      port: url.port,
      protocol: url.protocol.split(':')[0],
      // remove ":"
      'api-path': apiPath
    };
  };
});